module.exports = __webpack_public_path__ + "img/9.2ec9d67a.png";